import * as React from 'react';
import TagManager from 'react-gtm-module';
import { useAuth } from 'react-oidc-context';

import { useLocation } from 'react-router';
import { useConfig } from '~/common/context';

export function GtmTackingProvider(props: React.PropsWithChildren) {
  const location = useLocation();
  const auth = useAuth();
  const config = useConfig();
  React.useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        pagePath: location.pathname,
        userId: auth.user?.profile.sub ?? 'guest',
        tenant: config.tenantCode,
      },
      dataLayerName: 'PageDataLayer',
    });
  }, [auth.user?.profile.sub, config.tenantCode, location.pathname]);

  return <>{props.children}</>;
}
